import api from 'api/axiosInstance';

export enum VerifyBeneficiaryStatus {
  CloseMatch = 'CloseMatch',
  Match = 'Match',
  NoMatch = 'NoMatch',
  VerificationNotPossible = 'VerificationNotPossible',
}

export interface VerifyBeneficiaryBody {
  name: string;
  iban: string;
}

export interface VerifyBeneficiaryResponse {
  name: string;
  iban: string;
  status: VerifyBeneficiaryStatus;
  verificationToken: string;
  expiresAt: string;
  nameSuggestion?: string;
}

const verifyBeneficiary = (
  body: VerifyBeneficiaryBody,
): Promise<VerifyBeneficiaryResponse> =>
  api.post('/v2/accountable-banking/beneficiaries/verify', body);

export default verifyBeneficiary;
